import React, { Component } from 'react'
import { Form, TimePicker, Checkbox } from 'antd';
import { InputNumber } from '../../../../../components/common/input-number';
import { Dropdown } from '../../../../../components/common/dropdown';

export class RentalRatesDriverless extends Component {
  state = {
    fuel_types: [],
  }

  onSelectFuelType = data => {
    const { onChangeForm } = this.props;
    onChangeForm('fuel_type_code', data.code);
  }

  render() {
  
    const { limitEdit, isEdit, unlimitEdit, isOwner, typeOption } = this.props;
    const { fuel_types } = this.state;
    return <>
      <div className="title-contract">9. Mức giá thuê theo tháng, định mức và phụ phí đi kèm (Chưa gồm VAT)*</div>
      <Form.Item
        wrapperCol={15}
        name={'CT001'}
        label={`+ Giá thuê tháng::`}>
        <InputNumber className={(!isOwner && typeOption !== 'create_new') ? 'hidePrice' : ''} is_money disabled={!limitEdit || (typeOption !== 'create_new' && !isOwner)} suffix={"VNĐ/xe"} />
      </Form.Item>

      <div className="sub-title">* Định mức đi kèm</div>
      <Form.Item
        wrapperCol={15}
        name={'OLQ001'}
        label={`+ Định mức km::`}
        rules={[
          {
            required: true,
            message: `Vui lòng nhập định mức km!`,
          }
        ]}>
        <InputNumber disabled={!limitEdit} suffix={"Km/tháng"} />
      </Form.Item>

      <Form.Item
        wrapperCol={15}
        name={'OLQ005'}
        label={<div className="label-special"><div className="plus">+</div><div>Định mức nhiên liệu:</div></div>}
        rules={[
          {
            required: true,
            message: `Vui lòng nhập định mức nhiên liệu!`,
          }
        ]}>
        <InputNumber percent disabled={!limitEdit} suffix={"lít/100km"} />
      </Form.Item>

      <Form.Item
        wrapperCol={15}
        label={<div className="label-special">
          <div className="plus">+</div>
          <div>% điều chỉnh của nhiên liệu:</div>
        </div>}
        name={'fuel_adjust_percent'}
        rules={[
          // {
          //   required: true,
          //   message: `Vui lòng nhập định tỷ lệ phạt!`,
          // },
          {
            pattern: /^100$|^[0-9]{1,2}$|^[0-9]{1,2}\.[0-9]{1,100}$/,
            message: `Vui lòng nhập giá trị trong trong khoảng 0-100!`,
          },
        ]}>
        <InputNumber percent disabled={!limitEdit} max={100} suffix={"%"} />
      </Form.Item>

      <Form.Item
        className="working-day"
        name={'fuel_type_code'}
        label={`+ Loại nhiên liệu::`}
        rules={[
          {
            required: true,
            message: `Vui lòng chọn loại nhiên liệu!`,
          }
        ]}>
        <Dropdown
          disabled={!unlimitEdit}
          select={this.onSelectFuelType}
          className="dropdown-full"
          title="Chọn loại nhiên liệu"
          menu={fuel_types} />
      </Form.Item>

      <Form.Item
        wrapperCol={15}
        name={'CT019'}
        label={`+ Giá nhiên liệu::`}>
        <InputNumber className={(!isOwner && typeOption !== 'create_new') ? 'hidePrice' : ''} is_money disabled={!limitEdit || (typeOption !== 'create_new' && !isOwner)} suffix={"VNĐ/lít"} />
      </Form.Item>
      
      <Form.Item
        name={'CT003'}
        label={<div className="label-special"><div className="plus">+</div><div>Phụ phí vượt KM</div></div>}
      >
        <InputNumber className={(!isOwner && typeOption !== 'create_new') ? 'hidePrice' : ''} is_money disabled={!limitEdit || (typeOption !== 'create_new' && !isOwner)} suffix={'VNĐ/km'} />
      </Form.Item>
    </>
  }
}
